module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Penpergwm Solar Farm","short_name":"Penpergwm","start_url":"/","background_color":"#44546A","theme_color":"#44546A","display":"minimal-ui","icon":"src/images/solarpanels1.jpg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ee86c010e0cfa12f25d102e13038f830"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
